import { HttpClient } from '@angular/common/http';
import { Injectable, computed, effect, inject, signal } from '@angular/core';
import { take } from 'rxjs';
import { SceneStore } from '../stores/scene.store';

export interface MessageEntry {
  key: string;
  msg: string;
  threshold: number;
  window: number;
  type?: 'good' | 'mistake';
}

export interface MessageData {
  phaseMessages: MessageEntry[];
  mistakeMessages: MessageEntry[];
}

@Injectable({
  providedIn: 'root',
})
export class MessagesToAIService {
  private http = inject(HttpClient);
  private sceneStore = inject(SceneStore);

  private phaseMessagesSignal = signal<MessageEntry[]>([]);
  private mistakeMessagesSignal = signal<MessageEntry[]>([]);

  readonly phaseMessages = computed(() => this.phaseMessagesSignal());
  readonly mistakeMessages = computed(() => this.mistakeMessagesSignal());

  constructor() {
    effect(() => {
      this.http
        .get<MessageData>(this.sceneStore.path() + '/suturing-messages.json')
        .pipe(take(1))
        .subscribe((data) => {
          this.phaseMessagesSignal.set(data.phaseMessages);
          this.mistakeMessagesSignal.set(data.mistakeMessages);
        });
    });
  }
}
